/* eslint-disable @typescript-eslint/no-duplicate-enum-values -- copied verbatim from the Angular app; the duplicate value is part of the contract */
export enum NotificationHeader {
  deleteConfirmation = 'Confirm delete',
  archiveConfirmation = 'Confirm archive',
  restoreConfirmation = 'Confirm restore',
  success = 'Success!',
  error = 'Error!',
}

export enum NotificationDetails {
  deleteDetailText = 'Are you sure you want to delete <strong> ',
  questionMark = ' </strong> ?',
  archiveDetailText = 'Are you sure you want to archive the data? ',
  restoreDetailText = 'Are you sure you want to restore the data? ',
  deleteAllDetailText = 'Please confirm you want to delete these things. Deleting cannot be undone.',
}

export enum NotificationTextMessage {
  autoPeriodGenerationMessage = 'Auto Period Generated Successfully',
  lockPeriodMessage = 'Autounting Period Locked Sucessfully',
  unlockPeriodMessage = 'Autounting Period Unlocked Sucessfully',
  ceasedMessage = 'Autounting Period Ceased Sucessfully',
  continueMessage = 'Autounting Period continue Sucessfully',
  markComparativeMessage = 'Autounting Period Mark Comparative Sucessfully',
  undoComparativeMessage = 'Autounting Period undo Comparative Sucessfully',
  qtyErrorMessage = 'Quantity should be greater than 0',
  amtErrorMessage = 'Amount should be greater than 0',
  successMessage = 'The operation completed Successfully!',
  errorMessage = 'There might be some error occured!',
  bankAccountAlreadyExits = 'Bank account already exits!',
  recordCopySuccessfully = 'Record copied successfully',
  recordArchivedSuccessfully = 'Record archived successfully',
  recordRestoredSuccessfully = 'Record restored successfully',
  recordDeletedSuccessfully = 'Record deleted successfully',
  noRecordFoundText = 'No record found.',
  dateRangeTo = 'To date should be greater than 1 year from period From',
  dateRangeAccountsDue = 'Accounts Due Date should be greater than 9 months from To Date',
  dateRangeCT600DueDate = 'CT600 Due Date should be greater than 1 year from To date',
  uploadfileError = 'Please upload valid file',
  htmlfiletypeError = 'Please upload .html files only',
  pdffiletypeError = 'Please upload .pdf files only',
  nofileError = 'Please upload file',
  supplementaryFormsError = 'oops! few fields have invalid data please correct!.',
  FormsError = 'oops! few fields have invalid data please correct!.',
  emailMsg = 'Email sent successfully',
  clientAssignError = 'Please select atleast one client!',
  clientAssignSuccess = 'Client assigned Successfully!',
  L35fieldError = 'Box L35 must be less than or equal to Box 515',
  InvalidDate = 'Please enter valid date',
  validationMessage = 'Please fill all the mandatory fields.',
  selectOneOrMoreRecordToDelete = 'Select one or more records to delete',
  selectRecordToExport = 'Select one or more records to export',
  fileSizeExceeds = 'File should be less than 10 MB',
  fileSize5mb = 'File should be less than 5 MB',
  fileSize2mb = 'File should be less than 2 MB',
  fileJpgPng = 'File should be .png or .jpg extension',
  fileNameWithSpecialCharacter = 'File name should not contain special character',
}

export enum CommonNotificationText {
  NoRecordsFound = 'No records found',
  NoRecordsFoundForFilter = 'No records found for the given search/filter values',
  Active = 'Active',
  Archived = 'Archived',
  Error = 'Error',
  Submitted = 'Submitted',
  InProgress = 'In Progress',
  NotCreated = 'Not Created',
  NotAuthorized = 'Not Authorized',
  Authorized = 'Authorized',
  Activated = 'Activated',
  Activate = 'Activate',
}
